import { Moon, Sun } from "lucide-react"
import { useTheme } from "@/components/theme-provider"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const isDark = theme === "dark"

  return (
    <div className="theme-toggle-container">
      <Sun className={`h-4 w-4 transition-colors ${isDark ? 'text-gray-400' : 'text-yellow-500'}`} />
      <button
        onClick={() => setTheme(isDark ? "light" : "dark")}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-300 ease-in-out 
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent
          ${isDark 
            ? 'bg-gradient-to-r from-blue-600 to-blue-500 focus:ring-blue-400' 
            : 'bg-gradient-to-r from-gray-300 to-gray-400 focus:ring-gray-400'
          }
          hover:shadow-lg
        `}
        role="switch"
        aria-checked={isDark}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full shadow-lg transition-all duration-300 ease-in-out
            ${isDark 
              ? 'translate-x-6 bg-white' 
              : 'translate-x-1 bg-white'
            }
          `}
        >
          {/* Inner icon for better visual feedback */}
          <div className="flex items-center justify-center h-full w-full">
            {isDark ? (
              <Moon className="h-2 w-2 text-blue-600" />
            ) : (
              <Sun className="h-2 w-2 text-yellow-500" />
            )}
          </div>
        </span>
      </button>
      <Moon className={`h-4 w-4 transition-colors ${isDark ? 'text-blue-400' : 'text-gray-400'}`} />
    </div>
  )
}